// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import axios from 'axios';
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'  //关键代码
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
})



// WEBPACK FOOTER //
// ./src/main.js